import { colors, screen } from 'components/styles/variables';

const numberInputBoxStyles = `
  .number-input-box {
    width: 98px;
    height: 36px;
    padding: 8px;
    border: 1px solid ${colors.G2};
    border-radius: 4px;
    caret-color: ${colors.ALR1};
    text-align: center;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
    position: relative;
    top: -2px;
    box-sizing: border-box;
    
    &:focus-within {
      .number-input-box {
        border: 1px solid ${colors.BLACK};
      }
    }
  }
  @media (max-width: ${screen.mobileMax}) {
      .number-input-box {
        width: 108px;
        font-size: 16px;
        padding-bottom: 12px;
        line-height: 26px;
      }
    }
`;

export default numberInputBoxStyles;
